import React, { FC, Fragment } from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Theme,
    useMediaQuery,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LabClient } from 'models/client-directory';
import InfiniteScroll from 'react-infinite-scroll-component';
import useFixMissingScroll from 'utils/use-fix-missing-scroll';
import SupplierItem from '../supplier-item/supplier-item.component';

type SupplierListProps = {
    filteredSuppliers: LabClient[];
    onFetchMoreChange: () => void;
};
const SuppliersList: FC<SupplierListProps> = ({ filteredSuppliers, onFetchMoreChange }: SupplierListProps) => {
    const { t: translate } = useTranslation(['common']);
    const isLargeScreen = useMediaQuery((theme: Theme) => theme.breakpoints.up('xl'));
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

    // Fix for infinite scroll not working on some screen sizes.
    useFixMissingScroll(onFetchMoreChange, filteredSuppliers?.length || 0);

    return (
        <Fragment>
            <InfiniteScroll
                dataLength={filteredSuppliers.length}
                next={onFetchMoreChange}
                hasMore={true}
                throttleTimeInMs={75}
                loader={undefined}
            >
                <TableContainer component={Paper}>
                    <Table size={!isLargeScreen ? 'small' : 'medium'}>
                        <TableHead>
                            <TableRow>
                                <TableCell>{translate('common:NAME')}</TableCell>
                                <TableCell>{translate('common:ADDRESS')}</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredSuppliers?.map((supplier, index) => (
                                <SupplierItem key={index} supplier={supplier} />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </InfiniteScroll>
        </Fragment>
    );
};

export default SuppliersList;
